<template>
<div class="homework__item">
  <div class="homework__date"><span class="ico-calendar" uk-tooltip="Дата"></span> <span>{{ date }}</span></div>
  <div class="homework__trainer hwtrainer" v-for="trainer in group" :key="trainer.id">
    <ul class="hwtrainer__items">
      <li class="hwtrainer__item">
        <div class="homework__content">
          <div class="homework__title">            
            <div class="trainer-info">
              <span>
                {{ trainer[0].homework.trainer ? trainer[0].homework.trainer.title : trainer[0].homework.params.title }}
              </span>                           
            </div>

            <div>
              <span 
                class="uk-badge" 
                uk-tooltip="Количество повторов" 
                v-if="trainer[0].homework.trainer_id"
              >
                {{ trainer[0].homework.qnt }}
              </span> 
              <span class="uk-badge uk-badge--edit" uk-tooltip="Редактировать настройки домашнего задания" uk-icon="pencil" @click="editHW(trainer[0])"></span>
              <span class="uk-badge uk-badge--delete" uk-tooltip="Удалить задание" uk-icon="close" @click="openPopup('RemoveHomework', trainer)"></span>
            </div>
          </div>
          <TrainerInfo 
            :trainer="trainer[0].homework.trainer" 
            :params="trainer[0].homework.params"
          />
          <div class="homework__params homework__params--students">
            <small>Ученики:</small>
            <span>{{ students(trainer) }}</span>
          </div>
        </div>
      </li>
    </ul>
  </div>

  <Popup :isOpened="popupIsOpened" @close="popupIsOpened = false">
    <template v-slot:content>
      <component 
        :is="popupContent" 
        :data="popupData" 

        @close-popup="popupIsOpened = false" 
      ></component>
    </template>
  </Popup>
</div>
</template>

<script>
import TrainerInfo from '../../trainer/TrainerInfo.vue'
import RemoveHomework from './RemoveHomework.vue'

import { deleteItem } from '../../../other/methods/list_actions'
import { popup_mix } from '../../../mixins/popup_mix'

export default {
  name: "homeworks_item",
  inject: ['http'],
  mixins: [ popup_mix ],
  components: { TrainerInfo, RemoveHomework },
  data() {
    return {
      dates: '',
      group: ''
    }
  },
  props: {
    items: '',
    date: ''
  },
  methods: {
    deleteItem,
    showAlert(item) {
      UIkit.modal.dialog(item.homework.params.desc);
    },
    groupByTrainer() {
      let group = _.groupBy(this.items, 'homework_id');
      this.group = group;
      console.log(this.group)
    },
    /** Возвращаем дробное число */
    isInt(val) {
      if (Number.isInteger(val)) {
        return val + '.0';
      } else {
        return val;
      }
    },
    /** Split */
    split(str, razd) {
      return str.split(razd);
    },
    students(items) {
      let all = this.$parent.item.students;
      let local_all = [],
        names = [];
      _.forEach(items, function (i) {
        if(!i.student) return;
        local_all.push(i.student.id);
        names.push(i.student.name);
      });

      if (_.difference(all, local_all).length === 0) {
        return 'Все ученики класса';
      } else {
        return names.join(', ');
      }
    },
    editHW(item) {
      this.$emit('edit-homework', item.homework);
    },
  },
  mounted() {
    this.groupByTrainer();
  },
  watch: {
    items() {
      this.groupByTrainer()
    }
  }
}
</script>

<style lang="scss" scoped>
.trainer-info {
  position: relative;
  display: flex;
}
</style>
